import React, {
  useState,
  useContext,
  createContext,
  useMemo,
  useEffect,
} from "react";
import {
  NavBar,
  Icon,
  Tabs,
  DatePicker,
  List,
  WhiteSpace,
  Button,
} from "antd-mobile";
import { useHistory } from "react-router-dom";
import Moment from "moment";
import { useAppContext } from "../components/appContext/app-provider";
import {
  DateFilterType,
  FiltroDataModel,
} from "../components/appContext/app-model";

interface FiltroDataContextProps {
  setFilterDate(value: Date): void;
  setComparableFilterDate(value: Date): void;
  setFilterType(type: DateFilterType): void;
  saveToAppContext(): void;
  dateFilterType?: DateFilterType;
  dateFilter?: Date;
  comparableDateFilter?: Date;
}

const FiltroDataContext = createContext<FiltroDataContextProps | undefined>(
  undefined
);

const FiltroDataProvider = (props: any) => {
  const [state, setState] = useState<FiltroDataModel>();
  const appContext = useAppContext();

  useEffect(() => {
    const filtroModel = appContext.model.filtroModel;
    setState({
      dateFilterType:
        filtroModel?.dateFilterType === undefined
          ? 1
          : filtroModel?.dateFilterType,
      dateFilter: filtroModel?.dateFilter || new Date(),
      comparableDateFilter: filtroModel?.comparableDateFilter || new Date(),
    });
  }, [appContext]);

  const providerValue = useMemo(() => {
    const setFilterDate = (value: Date) => {
      setState({ ...state, dateFilter: value });
    };

    const setComparableFilterDate = (value: Date) => {
      setState({ ...state, comparableDateFilter: value });
    };

    const setFilterType = (type: DateFilterType) => {
      setState({ ...state, dateFilterType: type });
    };

    const saveToAppContext = () => {
      appContext.actions.setFilterDates({
        dateFilterType: state?.dateFilterType,
        dateFilter: state?.dateFilter,
        comparableDateFilter: state?.comparableDateFilter,
      });
    };

    return {
      ...state,
      setFilterDate,
      setComparableFilterDate,
      setFilterType,
      saveToAppContext,
    };
  }, [state, appContext.actions]);

  return <FiltroDataContext.Provider value={providerValue} {...props} />;
};

export function FiltroDataPage() {
  return (
    <FiltroDataProvider>
      <FiltroDataTab />
    </FiltroDataProvider>
  );
}

function FiltroDataTab() {
  const history = useHistory();
  const context = useContext(FiltroDataContext);
  const tabs = [{ title: "DIA" }, { title: "SEMANA" }, { title: "MÊS" }];

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <NavBar
        mode="dark"
        icon={<Icon type="left" />}
        onLeftClick={() => history.goBack()}
      >
        Filtro data
      </NavBar>

      <Tabs
        tabs={tabs}
        initialPage={context?.dateFilterType}
        page={context?.dateFilterType}
        onChange={(tab, index) => {
          context?.setFilterType(index);
        }}
        swipeable={false}
      >
        {DayPage()}
        {WeekPage()}
        {MonthPage()}
      </Tabs>
      <div style={{ padding: "20px" }}>
        <Button
          type="primary"
          onClick={() => {
            context?.saveToAppContext();
            history.goBack();
          }}
        >
          SALVAR
        </Button>
      </div>
    </div>
  );
}

function DayPage() {
  const context = useContext(FiltroDataContext);

  return (
    <div style={{ padding: "12px" }}>
      <DatePicker
        mode="date"
        title="Selecione o dia"
        extra="Selecione"
        format={(date) => Moment(date).format("ddd, D MMM, yyyy")}
        value={context?.dateFilter}
        onChange={(date) => context?.setFilterDate(date)}
      >
        <List.Item arrow="horizontal">Dia</List.Item>
      </DatePicker>
      <WhiteSpace />
      <DatePicker
        mode="date"
        title="Selecione o dia comparativo"
        extra="Selecione"
        format={(date) => Moment(date).format("ddd, D MMM, yyyy")}
        value={context?.comparableDateFilter}
        onChange={(date) => context?.setComparableFilterDate(date)}
      >
        <List.Item arrow="horizontal">Dia comparativo</List.Item>
      </DatePicker>
    </div>
  );
}

function WeekPage() {
  const context = useContext(FiltroDataContext);

  return (
    <div style={{ padding: "12px" }}>
      <DatePicker
        mode="date"
        title="Selecione a data final"
        extra="Selecione"
        format={(date) => Moment(date).format("ddd, D MMM, yyyy")}
        value={context?.dateFilter}
        onChange={(date) => context?.setFilterDate(date)}
      >
        <List.Item arrow="horizontal">Último dia da semana</List.Item>
      </DatePicker>
      <WhiteSpace />
      <DatePicker
        mode="date"
        title="Selecione a data final comparativa"
        extra="Selecione"
        format={(date) => Moment(date).format("ddd, D MMM, yyyy")}
        value={context?.comparableDateFilter}
        onChange={(date) => context?.setComparableFilterDate(date)}
      >
        <List.Item arrow="horizontal">Semana comparativa</List.Item>
      </DatePicker>
    </div>
  );
}

function MonthPage() {
  const context = useContext(FiltroDataContext);

  return (
    <div style={{ padding: "12px" }}>
      <DatePicker
        mode="month"
        title="Selecione o mês"
        extra="Selecione"
        format={(date) => Moment(date).format("MMMM, yyyy")}
        value={context?.dateFilter}
        onChange={(date) => context?.setFilterDate(date)}
      >
        <List.Item arrow="horizontal">Mês</List.Item>
      </DatePicker>
      <WhiteSpace />
      <DatePicker
        mode="month"
        title="Selecione o mês comparativo"
        extra="Selecione"
        format={(date) => Moment(date).format("MMMM, yyyy")}
        value={context?.comparableDateFilter}
        onChange={(date) => context?.setComparableFilterDate(date)}
      >
        <List.Item arrow="horizontal">Mês comparativo</List.Item>
      </DatePicker>
    </div>
  );
}
